export const utils = {
    townList: [
        // {name: '商河县', id: '0'},
        {name: '殷巷镇', id: '5162', lon: 117.143351, lat: 37.400843},
        {name: '怀仁镇', id: '5163', lon: 117.045055, lat: 37.406775},
        {name: '龙桑寺镇', id: '5164', lon: 117.295802, lat: 37.383443},
        {name: '郑路镇', id: '5165', lon: 117.326504, lat: 37.277404},
        {name: '贾庄镇', id: '5166', lon: 117.075444, lat: 37.256027},
        {name: '玉皇庙镇', id: '5167', lon: 117.097191, lat: 37.184769},
        {name: '白桥镇', id: '5168', lon: 117.237303, lat: 37.217099},
        {name: '孙集镇', id: '5169', lon: 117.263544, lat: 37.298186},
        {name: '韩庙镇', id: '5170', lon: 117.242998, lat: 37.492606},
        {name: '沙河镇', id: '5171', lon: 117.277266, lat: 37.426169},
        {name: '张坊镇', id: '5172', lon: 117.100863, lat: 37.352103},
        {name: '许商街道', id: '6048', lon: 117.163026, lat: 37.255053},
    ],
    townNameList: ['殷巷镇', '怀仁镇', '龙桑寺镇', '郑路镇', '贾庄镇', '玉皇庙镇', '白桥镇', '孙集镇', '韩庙镇', '沙河镇', '张坊镇', '许商街道'],
    getToday() {
        const currTime = new Date()
        let strDate = currTime.getFullYear() + "-"
        let mm = currTime.getMonth() + 1
        if (mm > 0 && mm < 10) {
            mm = "0" + mm + "-"
        } else {
            mm = mm + "-"
        }
        strDate += mm
        let dd = currTime.getDate()
        if (dd > 0 && dd < 10) {
            dd = "0" + dd
        }
        strDate += dd
        return strDate
    },
    supplyServiceTypeList: [
        {id: -1, name: '全部'},
        {id: 1, name: '深松'},
        {id: 2, name: '旋耕'},
        {id: 3, name: '深耕'},
        {id: 4, name: '播种'},
        {id: 5, name: '飞防植保'},
        {id: 6, name: '自走植保'},
        {id: 7, name: '统防统治'},
        {id: 8, name: '收获'},
        {id: 9, name: '秸秆还田'},
        {id: 10, name: '秸秆打捆'},
        {id: 11, name: '技术指导'},
        {id: 12, name: '烘干'},
        {id: 13, name: '收购'},
        {id: 14, name: '全托管'},
        {id: 15, name: '机械施肥'},
        {id: 16, name: '飞防植保'},
        {id: 17, name: '饲料'},
        {id: 18, name: '兽药'},
        {id: 19, name: '防疫'},
    ],
    getNearTwelveMonth() {
        const dataArr = []
        const data = new Date()
        const year = data.getFullYear()
        data.setMonth(data.getMonth() + 1)//获取到当前月份,设置月份
        for (let i = 0; i < 12; i++) {
            data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
            let dd = data.getMonth() + 1
            if (dd > 0 && dd < 10) {
                dd = "0" + dd
            }
            dataArr.push(data.getFullYear() + "-" + dd)
        }
        return dataArr
    },
    randomNum(len, radix) {
        const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
        const uuid = []
        radix = radix || chars.length
        if (len) {
            // Compact form
            for (let i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix ]
        } else {
            // rfc4122, version 4 form
            let r
            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
            uuid[14] = '4'
            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (let i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16
                    uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
                }
            }
        }
        return uuid.join('') + new Date().getTime()
    }
}